import { Icon } from "@iconify/react/dist/iconify.js";
import { tinaField } from "tinacms/dist/react";
import type { PageHomeBenefits } from "../../../tina/__generated__/types";

interface MainBlockProps {
  benefits: PageHomeBenefits | null;
}

export const MainBlock = ({ benefits }: MainBlockProps) => {
  if (!benefits) return null;

  const items = benefits.items?.filter((item) => item !== null) ?? [];

  return (
    <div className="max-w-7xl mb-5 m-auto text-left text-gray-900 dark:text-gray-200 px-12">
      {benefits.intro && <p data-tina-field={tinaField(benefits, "intro")}>{benefits.intro}</p>}
      <ul className="list-inside mb-4 mt-4">
        {items.map((item) => (
          <li key={item.title} data-tina-field={tinaField(item)}>
            <span data-tina-field={tinaField(item, "icon")}>
              {item.icon && <Icon icon={item.icon} className="text-2xl mr-1 inline-block" />}
            </span>
            <span className="font-semibold" data-tina-field={tinaField(item, "title")}>
              {item.title}
            </span>{" "}
            <span data-tina-field={tinaField(item, "text")}>{item.text}</span>
          </li>
        ))}
      </ul>
      {benefits.outro && <p data-tina-field={tinaField(benefits, "outro")}>{benefits.outro}</p>}
    </div>
  );
};
export default MainBlock;
